import axios  from "axios"

const useRefreshToken = () => {
    const refreshToken = async () => {
        try {
        const response = await axios.post("api/login/refresh-token", {
            withCredentials: true,
        });
        localStorage.setItem('token', response.data);
        return response.data;
    } catch (error) {

        
    }

    }
  return refreshToken;
}

export default useRefreshToken